import React, {FC} from 'react';
import {IonBackButton, IonButtons, IonMenuButton} from '@ionic/react';
import {chevronBackOutline, arrowBackOutline} from 'ionicons/icons';

type UIBackButtonProps = {
  title?: string;
  href?: string;
  style?: string;
}

const UIBackButton: FC<UIBackButtonProps> = ({title, href, style}) => {
  return (
    <IonButtons className={`flex justify-between w-full text-navy-primary ${style}`}>
      <div className='md:bg-gray-lightButton flex flex-row items-center rounded-xl'>
        <IonBackButton
          className={
            'normal-case hidden md:block bg-gray-menu border border-navy-primary rounded-md ' +
            'px-3 max-h-[30px]'}
          text='Tillbaka'
          defaultHref={href}
          icon={arrowBackOutline}></IonBackButton>
        <IonBackButton
          mode='md'
          className='md:hidden'
          icon={chevronBackOutline}
          defaultHref={href}></IonBackButton>
      </div>
      <div className='md:hidden font-Outfit font-semibold text-navy-primary text-xl md:text-2xl'>{title}</div>
      <IonMenuButton mode='md' ></IonMenuButton>
    </IonButtons>
  );
};

export default UIBackButton;
